import "./style.scss";
import { FC } from "react";
import { useSelector } from "react-redux";
import { AOPMaltaAdmissionData } from "@/src/types/admissionOffice";
import type { RootState } from "@/src/store";
import { isFeuComUaOffice, toOfficeUrlForApi } from "@/src/utils/accessControl/formatOfficeUrl";
import type { AdmissionOfficeCountry } from "../../../admissionOfficeCountry";
import { getAdmissionOfficePreviewBackground } from "@/src/utils/admissionOffice/getAdmissionOfficePreviewBackground";

interface AOPPrevProps {
  country: AdmissionOfficeCountry;
  bodyForPrev: AOPMaltaAdmissionData;
  showInvoiceInPreview: boolean;
  withQR?: boolean;
}

const AOPPrev: FC<AOPPrevProps> = ({ country, bodyForPrev, showInvoiceInPreview, withQR = true }) => {
  const selectedSiteUrl = useSelector((state: RootState) => state.accessControl.selectedSiteUrl);
  const contextOfficeUrl = useSelector((state: RootState) => state.admissionOfficeDoc.officeUrl);
  const officeUrl = toOfficeUrlForApi(contextOfficeUrl) ?? selectedSiteUrl;
  const isFeuUa = country === "ukraine" && isFeuComUaOffice(officeUrl);
  const actualBg = getAdmissionOfficePreviewBackground(country, withQR, officeUrl);
  const dateLine = bodyForPrev.currentDate ? bodyForPrev.currentDate : "-";

  const prevClassName = `admission-office-prev ${country} admission${isFeuUa ? " feu" : ""}`;

  const numberAndDate = isFeuUa ? (
    <div className="admission-office-prev-section number-and-date">
      <span>{dateLine}</span>
      <span>No -</span>
    </div>
  ) : (
    <div className="admission-office-prev-section number-and-date">
      <span>№ -</span>
      <span>Date: {dateLine}</span>
    </div>
  );

  return (
    <div className="admission-office-prev-wrapper">
      <div className={prevClassName}>
        <img className="admission-office-prev-background" src={actualBg} alt="" />
        {!isFeuUa ? <div className="admission-office-prev-section title">ADMISSION/CONFIRMATION LETTER</div> : null}
        {numberAndDate}
        <div className="admission-office-prev-section info">
          <p>Full Name: {bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth ? bodyForPrev.dateOfBirth : ""}</p>
          <p>Nationality: {bodyForPrev.nationality ? bodyForPrev.nationality : ""}</p>
          <p>Course: {bodyForPrev.course ? bodyForPrev.course : ""}</p>
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction ? bodyForPrev.mediumOfInstruction : ""}</p>
          <p>Duration: {bodyForPrev.duration ? bodyForPrev.duration : ""}</p>
        </div>
        {!isFeuUa ? (
          <div className="admission-office-prev-section signature">
            <p>Head of Foreign Students department</p>
            <p>Fedorova Anzhelika</p>
            <p>International European University</p>
          </div>
        ) : null}
        {bodyForPrev ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.body?.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
      {showInvoiceInPreview ? (
        <div className={prevClassName}>
          <img className="admission-office-prev-background" src={actualBg} alt="" />
          {!isFeuUa ? <div className="admission-office-prev-section title">INVOICE</div> : null}
          {numberAndDate}
          <div className="admission-office-prev-section info">
            <p>Full Name: {bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
            <p>Data of Birth: {bodyForPrev.dateOfBirth ? bodyForPrev.dateOfBirth : ""}</p>
            <p>Nationality: {bodyForPrev.nationality ? bodyForPrev.nationality : ""}</p>
            <p>Course: {bodyForPrev.course ? bodyForPrev.course : ""}</p>
            <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction ? bodyForPrev.mediumOfInstruction : ""}</p>
            <p>Duration: {bodyForPrev.duration ? bodyForPrev.duration : ""}</p>
          </div>
          {!isFeuUa ? (
            <div className="admission-office-prev-section signature">
              <p>Head of Foreign Students department</p>
              <p>Fedorova Anzhelika</p>
              <p>International European University</p>
            </div>
          ) : null}
          <div className="admission-office-prev-section body-content">
            {(bodyForPrev.invoiceBody ?? []).map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AOPPrev;
